"use strict";
var __createBinding = (this && this.__createBinding) || (Object.create ? (function(o, m, k, k2) {
    if (k2 === undefined) k2 = k;
    var desc = Object.getOwnPropertyDescriptor(m, k);
    if (!desc || ("get" in desc ? !m.__esModule : desc.writable || desc.configurable)) {
      desc = { enumerable: true, get: function() { return m[k]; } };
    }
    Object.defineProperty(o, k2, desc);
}) : (function(o, m, k, k2) {
    if (k2 === undefined) k2 = k;
    o[k2] = m[k];
}));
var __setModuleDefault = (this && this.__setModuleDefault) || (Object.create ? (function(o, v) {
    Object.defineProperty(o, "default", { enumerable: true, value: v });
}) : function(o, v) {
    o["default"] = v;
});
var __importStar = (this && this.__importStar) || function (mod) {
    if (mod && mod.__esModule) return mod;
    var result = {};
    if (mod != null) for (var k in mod) if (k !== "default" && Object.prototype.hasOwnProperty.call(mod, k)) __createBinding(result, mod, k);
    __setModuleDefault(result, mod);
    return result;
};
var __importDefault = (this && this.__importDefault) || function (mod) {
    return (mod && mod.__esModule) ? mod : { "default": mod };
};
Object.defineProperty(exports, "__esModule", { value: true });
const lodash_1 = __importDefault(require("lodash"));
const react_1 = __importStar(require("react"));
const PageContexts_1 = require("../Contexts/PageContexts");
const mapHelpers_1 = require("../utils/mapHelpers");
const pathHelpers_1 = require("../utils/pathHelpers");
/**
 * This is a small component used to short circuit form controls which do not have a conditional map.
 * The reason we can't just put this in the actual Conditional component is that the conditional evaluation
 * requires looking up the current form state which is expensive, and that hook(like all hooks) can't be made conditional.
 * @param conditionalMap The mapping used to determine the visibility of the current form object
 */
const ComputedRenderer = props => {
    const { functionDefinitions } = (0, PageContexts_1.useControlProvider)();
    const { controlPath, controlDefinition, children } = props;
    const { pageState, setPageState } = (0, PageContexts_1.usePageState)();
    const [computedMap] = (0, react_1.useState)(controlDefinition.computedMap);
    const formDataMapping = (0, PageContexts_1.usePageDataMappingSources)(); // get any supplemental state to pass to data mapper
    const computedRefs = (0, react_1.useMemo)(() => (computedMap ? (0, pathHelpers_1.getRefs)(computedMap, ['FORM', 'FORMVALUE']) : {}), [computedMap]);
    const [firstComputedMap, setFirstComputedMap] = (0, react_1.useState)(false);
    const [previousState, setPreviousState] = (0, react_1.useState)({});
    const [previousValue, setPreviousValue] = (0, react_1.useState)({});
    // eslint-disable-next-line react-hooks/exhaustive-deps
    const calculatedCallback = (0, react_1.useCallback)(lodash_1.default.debounce((computedMap, acc, functionDefinitions, pageState, controlPath, firstComputedMap, previousState, previousValue, computedRefs) => {
        if (computedMap) {
            // now we need to build a set of data sources for our datamap
            //only check if the field has been interacted with, plus allow override for modal validation
            const allValues = pageState;
            const value = lodash_1.default.get(allValues, controlPath);
            const parts = (controlPath || '').split('.');
            const t = parts.map((part, idx) => {
                let target = allValues;
                let name = '';
                for (let i = 0; i < idx; i++) {
                    target = lodash_1.default.get(target, parts[i]);
                    name += parts[i].replace(/\[\d+\]/, '') + '.';
                }
                target = target ? lodash_1.default.get(target, part) : undefined;
                name += part.replace(/\[\d+\]/, '');
                return { [name]: target };
            });
            let formValue = { value };
            for (let i = 0; i < t.length; i++) {
                formValue = Object.assign(Object.assign({}, formValue), t[i]);
            }
            // only
            const accessors = Object.assign(Object.assign({}, acc), { FORM: () => {
                    return allValues;
                }, FORMVALUE: () => formValue });
            if (computedMap &&
                (!firstComputedMap ||
                    (computedRefs &&
                        ((0, pathHelpers_1.anyValuesChanged)(computedRefs['FORMVALUE'], previousValue, formValue) ||
                            (0, pathHelpers_1.anyValuesChanged)(computedRefs['FORM'], previousState, allValues))))) {
                (0, mapHelpers_1.fieldComputedMapEvaluator)(accessors, functionDefinitions, computedMap, true).then(val => {
                    if (!lodash_1.default.isEqual(val, value)) {
                        //allValues[controlPath] = val;
                        setPageState((prev) => lodash_1.default.set(lodash_1.default.cloneDeep(prev), controlPath, val));
                    }
                });
            }
            if (!lodash_1.default.isEqual(allValues, previousState)) {
                setPreviousState(lodash_1.default.cloneDeep(allValues));
            }
            if (!lodash_1.default.isEqual(formValue, previousValue)) {
                setPreviousValue(lodash_1.default.cloneDeep(formValue));
            }
            if (!firstComputedMap) {
                setFirstComputedMap(true);
            }
        }
    }, 300), []);
    // we're going to create a validation function that returns errors and warnings
    (0, react_1.useEffect)(() => {
        calculatedCallback(computedMap, formDataMapping.accessors, functionDefinitions, pageState, controlPath, firstComputedMap, previousState, previousValue, computedRefs);
    }, [
        computedMap,
        formDataMapping.accessors,
        functionDefinitions,
        pageState,
        controlPath,
        firstComputedMap,
        previousState,
        previousValue,
        computedRefs,
        calculatedCallback,
    ]);
    return react_1.default.createElement(react_1.default.Fragment, null, children);
};
exports.default = ComputedRenderer;
